<!-- Seção Hero (paisagem do início como fundo) -->
<app-igloo-hero mode="landscape">
  <h1 class="hero-title">O que a <span class="highlight-blue">IglooCode</span> faz</h1>
  <p class="hero-subtitle">Sites, lojas e identidade visual feitos do zero, <span class="highlight-blue"> no seu resultado</span></p>
</app-igloo-hero>com foco

<!-- Seção de Serviços Detalhados -->
<section class="services-section">
  <div class="services-container">
    <div class="services-grid">
      <article class="service-card" *ngFor="let service of services; let i = index" [id]="service.id">
        <span class="service-num">0{{ i + 1 }}</span>
        <div class="service-body">
          <h2 class="service-title">{{ service.title }}</h2>
          <p class="service-description">{{ service.description }}</p>
        </div>
        <a class="btn-orcamento" [href]="'https://wa.me/5548988527818?text=' + service.whatsappText" target="_blank">
          Solicitar orçamento &rarr;
        </a>
      </article>
    </div>
  </div>
</section>

<!-- Seção CTA -->
<section class="cta-section">
  <video class="cta-video" autoplay [muted]="true" loop playsinline>
    <source src="assets/img/ceu.mp4" type="video/mp4">
  </video>
  <div class="cta-overlay"></div>
  <div class="cta-content">
    <h2 class="cta-title">Qual desses serviços o seu <span class="highlight-blue">negócio precisa?</span></h2>
    <p class="cta-subtitle">Me manda uma mensagem, respondo rápido e sem enrolação</p>
    <a class="btn-whatsapp" href="https://wa.me/5548988527818?text=Olá!%20Gostaria%20de%20realizar%20um%20orçamento%20para%20a%20criação%20de%20uma%20página%20web" target="_blank">
      <i class="fa-brands fa-whatsapp"></i>
      Falar no WhatsApp
    </a>
  </div>
</section>

<app-footer></app-footer>
